var scrollToElement = function (element) {
  if (!element) return;
  var $innerListItem = $(element),
    $parentDiv = $(element).parent();

  $parentDiv.scrollTop(
    $parentDiv.scrollTop() + $innerListItem.position().top - $parentDiv.height() + $innerListItem.height()
  );
},
  setNavHeight = function () {
    setTimeout(function () {
      $('.carousel-nav-list').height(
        $('.productwithtext-carousel').find('.slick-slide[data-slick-index=0] img').height() -
        $('.carousel-btn').height() * 2
      );
    }, 250);
  };


window.onresize = function () {
  setNavHeight();
};

$(document).ready(function () {
  setNavHeight();
});

$(function () {
  $('a[href*="#"]:not([href="#"])').click(function () {
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
      location.hostname == this.hostname
    ) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html, body').animate(
          {
            scrollTop: target.offset().top,
          },
          1000
        );
        return false;
      }
    }
  });
});
window.zESettings = {
  webWidget: {
    chat: {
      suppress: true,
    },
    contactForm: {
      suppress: true,
    },
    helpCenter: {
      suppress: true,
    },
    talk: {
      suppress: true,
    },
    answerBot: {
      suppress: true,
    },
  },
};